module.exports = __webpack_public_path__ + "assets/img/vestamosnoaiq_desconto_black-story.5ba8b979.png";